/**
* @name: header-bar-page 
* @author: weiyong 
* @date: 2023-05-11 18:24 
* @description：header-bar-page 
* @update: 2023-05-11 18:24 
*/

<template>
  <header
    :class="[prefixCls, getHeaderClass]"
    class="el-header classicBlue-header is-pageHeader w100b flex-div-bet"
    :style="'--el-custom-header-bg-color:' + getHeaderBgColor"
  >
    <div class="header-left flex-div h100b">
      <!-- logo -->
      <AppLogo
        :showLogo="getShowLogo"
        :class="[`${prefixCls}-logo`, getHeaderTheme]"
        :theme="getHeaderTheme"
        :showTitle="getShowSystemTitle!==false"
      />
    </div>

    <div class="header-right" style="padding-right: 22px">
      <XmTenantDropdown />

      <AppLocalePicker class="icon-item" :reload="true" :showText="false" />
      <!-- <AppSearch v-if="getShowSearch" :class="`${prefixCls}-action__item  icon-item`" /> -->

      <!--门户选择-->
      <portal-sel-list v-if="isNotSystemOrGroup" />

      <!-- app下载 -->
      <AppDownImg v-if="getShowApp" :class="`${prefixCls}-action__item icon-item`" />

      <!--      消息-->
      <Notify
        style="cursor: pointer; padding: 0 12px"
        v-if="getShowNotice"
        :class="`${prefixCls}-action__item notify-item`"
      />

      <FullScreen :class="`${prefixCls}-action__item fullscreen-item  icon-item`" />

      <!--      机构下拉-->
      <!--      <org-drop-down-sca class="icon-item no-right-padding" ></org-drop-down-sca>-->
      <!--用户下拉-->
      <user-drop-down-sca class="icon-item no-right-padding" />

      <SettingDrawer
        v-if="getUserDefLayout !== false"
        :settingLayout="settingLayout"
        :class="[`${prefixCls}-action__item`, 'icon-item', 'SettingDrawer']"
      />

      <UpdateLogIcon class="icon-item" />
      <xm-icon-help class="icon-item" />
    </div>
  </header>
</template>

<script lang="ts" setup>
  import Notify from '@/layouts/default/header/components/notify/index.vue';
  import XmIconHelp from '@/layouts/default/header/components/xm-icon-help.vue';
  import UpdateLogIcon from '@/layouts/default/header/components/UpdateLogIcon.vue';
  import AppDownImg from '/@/layouts/default/header/components/AppDownImg.vue';
  import PortalSelList from '@/layouts/layoutFrame/portal-sel/portal-sel-list.vue';
  import { AppLogo } from '@/components/Application';
  import { AppLocalePicker } from '@/components/Application';
  import UserDropDownSca from '@/layouts/layoutFrame/scaLayout/components/user-drop-down-sca.vue';
  import { AppSearch } from '@/components/Application';
  import FullScreen from '@/layouts/default/header/components/FullScreen.vue';
  import { useDesign } from '@/hooks/web/useDesign';
  import { useHeaderSetting } from '@/hooks/setting/useHeaderSetting';
  import { computed, unref } from 'vue';
  import { useMenuSetting } from '@/hooks/setting/useMenuSetting';
  import { useRootSetting } from '@/hooks/setting/useRootSetting';
  import { XmTenantDropdown } from '@/components/xm-tenant-and-industry-toggle';
  import { createAsyncComponent } from '@/utils/factory/createAsyncComponent';
  import GoingUtils from '@/utils/goingUtils';

  defineOptions({
    components: {
      SettingDrawer: createAsyncComponent(() => import('@/layouts/default/setting/index.vue'), {
        loading: true,
      }),
    },
    name: 'header-bar-page',
  });

  const props = defineProps({
    settingLayout: {
      type: Boolean,
      default: true,
    },
  });

  const {  getShowLogo } = useRootSetting();

  const { prefixCls } = useDesign('classicBlue-header-bar-page');

  const { getShowNotice, getShowSystemTitle,getHeaderBgColor, getHeaderTheme,getShowApp,getShowSearch  } = useHeaderSetting();

  const isNotSystemOrGroup = computed(() => {
    return GoingUtils.isNotSystemOrGroup();
  });
  const { getSplit, getMenuWidth } = useMenuSetting();



  /**
   * 获取header都主题颜色
   */
  const getHeaderClass = computed(() => {
    const theme = unref(getHeaderTheme);
    return [
      prefixCls,
      {
        [`${prefixCls}--${theme}`]: theme,
      },
    ];
  });

  const { getUserDefLayout } = useRootSetting();
</script>

<style type="text/css" lang="less">
  @prefix-cls: ~'@{namespace}-classicBlue-header-bar-page';
  @logo-width: 55px;

  .@{prefix-cls} {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: @layout-sider-fixed-z-index + 5;
    background-color: var(--el-custom-header-bg-color);

    .menu-btn {
      width: var(--header-height, 60px);
      height: var(--header-height, 62px);
      .btn-icon {
        font-size: var(--font-menu-icon-size, 22px);
      }
      transition: all 0.3s;
    }
    .SettingDrawer {
      cursor: pointer;
    }
    &-logo {
      height: var(--header-height, 60px);

      padding: 0 10px;
      font-size: 14px;
      &.vben-app-logo.dark .vben-app-logo__title {
        color: #fff;
      }
      img {
        width: @logo-width;
        height: @logo-width;
        margin-right: 2px;
      }
    }

    &.classicBluel-header {
      box-shadow: 0 2px 4px 0 var(--cb-color-shadow, rgba(0, 0, 0, 0.16));
      height: var(--header-height, 60px);
      background-color: var(--el-custom-header-bg-color);
      padding: 0 40px;
      padding-left: 0;
      display: flex;
      gap: 24px;
      align-items: center;
      position: -webkit-sticky;
      position: sticky;
      justify-content: space-between;
      top: 0;
      width: 100%;
      box-sizing: border-box;
      z-index: 100;

      .icon {
        color: var(--primary-color, #0a6eff);
        vertical-align: middle;
        margin: 6px 0;
        font-size: 20px;
      }
    }

    .header-left{
      z-index: 1;
      width: 202px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .breadcrumb-container {
      height: 32px;
      display: inline-flex;
      align-items: center;
      gap: 24px;
      width: 100%;
    }

    .svg-inline--fa {
      display: var(--fa-display, inline-block);
      height: 1em;
      overflow: visible;
      vertical-align: -0.125em;
    }

    .el-txt.el-txt--h5 {
      font-family: var(--el-font-family);
      font-size: var(--el-h5-font-size);
      font-weight: var(--el-h5-font-weight);
      line-height: var(--el-h5-line-height);
      letter-spacing: var(--el-h5-letter-spacing);
      color: var(--el-text-color-primary, #303133);
    }

    .header-right {
      align-items: center;
      display: flex;
      .icon-item {
        display: inline-block;
        padding: 0 12px;
        &.no-right-padding {
          padding-right: 0;
        }
      }
    }
    .fullscreen-item {
      cursor: pointer;
    }

    .notify-item{
      height: 100%;
      display: flex;
      align-items: center;
    }
  }

  .classicBlue-header{
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);
  }
</style>
